import { Business } from '../../store/business';
import { BusinessCreateBody } from '../../store/business/create';
import { BusinessListGetParams } from '../../store/business/list';
import { PaginatedResponse } from '../../store/types';
import {
  DefaultFetchError,
  FetchCreate,
  FetchGet,
  useFetchCreate,
  useFetchGet,
} from '../fetch';

export const useBusinessesList = (params?: BusinessListGetParams): FetchGet<
  PaginatedResponse<Business>,
  BusinessListGetParams,
  DefaultFetchError
> => (
  useFetchGet('businesses', { autoStart: true, startStateLoading: false, params })
);

export const useBusinessCreate = (): FetchCreate<{ id: string }, DefaultFetchError, BusinessCreateBody> => (
  useFetchCreate('businesses', { autoStart: false, startStateLoading: false })
);
